module.exports = __webpack_public_path__ + "img/zoom-out-active.51e0cc9a.svg";